/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';
import { injectIntl } from 'react-intl';
import { Grid, Row, Col } from 'react-bootstrap';
import Nvl from 'loracoms/Nvl';
import Toolbar from 'loracoms/Toolbar';
import IntlMsg from 'lorautils/intl/IntlMsg';
import PageLoading from 'loracoms/PageLoading';
import PageNoPerm from 'loracoms/PageNoPerm';
import Parsers from './coms/Parsers';

const propTypes = {
  intl: React.PropTypes.any.isRequired,
  appId: React.PropTypes.string.isRequired,
  pushState: React.PropTypes.func.isRequired,
  app: React.PropTypes.object.isRequired,
  planState: React.PropTypes.object.isRequired,
};

class ParseView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      app: props.app,
      planState: props.planState,
    };
    this.intlMsg = new IntlMsg(props.intl, 'applicationdetail.parseview');
  }

  componentWillReceiveProps(nextProps) {
    const { app, planState } = nextProps;
    if (app !== this.props.app) {
      this.setState({ app });
    }
    if (planState !== this.props.planState) {
      this.setState({ planState });
    }
  }

  renderToolbar() {
    const { app } = this.state;
    const { data = {} } = app;

    const breadcrumb = [{
      onClick: () => this.props.pushState('/application'),
      content: this.intlMsg.msg('breadcrumb.application', 'application'),
    }, {
      content: <Nvl val={data.name} status={app.status} />,
      active: true,
    }];

    return <Toolbar breadcrumb={breadcrumb} />;
  }

  render() {
    const { planState } = this.state;
    const { appId } = this.props;

    if (planState.status === 'pending') {
      return <PageLoading />;
    }
    if (planState.data.tier === 1) {
      return <PageNoPerm />;
    }

    return (
      <Grid fluid>
        <Row>
          <Col md={12}>
            {this.renderToolbar()}
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <Parsers appId={appId} />
          </Col>
        </Row>
      </Grid>
    );
  }
}

ParseView.propTypes = propTypes;

const mapStateToProps = (state, ownProps) => ({
  appId: ownProps.params.id,
  app: state.app.getApp,
  planState: state.billing.plan,
});
const mapDispatchToProps = {
  pushState: routerActions.push,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(ParseView));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/ParseView/index.jsx